export default "__VITE_ASSET__v3iuuKJ___"